import { useCallback, useEffect } from "react";
import { clearRmlMediaBridge, setRmlMediaBridge } from "./rmlMediaBridge.js";
import { useAppTreeControllerRef, useAppTreeTreeRef } from "../../../contexts/appTreeControllerContext.js";
import { useAppTreeLocalState } from "../../../contexts/appTreeLocalStateContext.js";
import { useAppTreeMountContext } from "../../../contexts/appTreeMountContext.js";
import { useStores } from "../../../store/rootStore.js";
import { useOrderHandlers } from "../toolbar/useOrderHandlers.js";
import { useFetchTree } from "../useFetchTree.js";
import { useHandleSelect } from "../useHandleSelect.js";
function useRmlMediaBridge() {
    const controllerRef = useAppTreeControllerRef();
    const treeRef = useAppTreeTreeRef();
    const { treeStore } = useStores();
    const { attachmentsBrowser } = useAppTreeMountContext();
    const { resolvedInitialSelectedId, controllerState, setStatePatch } = useAppTreeLocalState();
    const { handleSelect } = useHandleSelect();
    const { handleOrderClick } = useOrderHandlers();
    const fetchTree = useFetchTree();
    const handleReload = useCallback(()=>{
        handleSelect();
    }, [
        handleSelect
    ]);
    if (!controllerRef.current) {
        controllerRef.current = {
            ref: null,
            attachmentsBrowser,
            props: {
                store: treeStore
            },
            state: controllerState,
            initialSelectedId: resolvedInitialSelectedId,
            setState: (update)=>{
                const patch = typeof update === "function" ? update(controllerRef.current.state) : update;
                setStatePatch(patch);
            },
            getSelectedId: ()=>treeStore.selectedId,
            getTreeItemById: (id, excludeStatic)=>treeStore.getTreeItemById(id, excludeStatic),
            handleReload,
            handleSelect,
            handleOrderClick,
            fetchCounts: treeStore.fetchCounts.bind(treeStore),
            fetchTree,
            handleDestroy: ()=>{}
        };
    }
    controllerRef.current.ref = treeRef.current;
    controllerRef.current.attachmentsBrowser = attachmentsBrowser;
    controllerRef.current.props = {
        store: treeStore
    };
    controllerRef.current.state = controllerState;
    controllerRef.current.initialSelectedId = resolvedInitialSelectedId;
    controllerRef.current.handleReload = handleReload;
    controllerRef.current.handleSelect = handleSelect;
    controllerRef.current.handleOrderClick = handleOrderClick;
    controllerRef.current.fetchTree = fetchTree;
    controllerRef.current.getSelectedId = ()=>treeStore.selectedId;
    controllerRef.current.getTreeItemById = (id, excludeStatic)=>treeStore.getTreeItemById(id, excludeStatic);
    if (attachmentsBrowser) {
        const bridge = {
            initialSelectedId: resolvedInitialSelectedId,
            selectFolder: (id)=>handleSelect(id),
            reloadCurrentFolder: ()=>{
                handleReload();
            },
            refreshTree: fetchTree,
            refreshFolderCounts: treeStore.fetchCounts.bind(treeStore),
            bindAttachmentDrag: ()=>controllerRef.current.makeDraggable?.(),
            refreshDropTargets: ()=>controllerRef.current.refreshDroppable?.()
        };
        setRmlMediaBridge(attachmentsBrowser, bridge, treeStore);
    }
    useEffect(()=>{
        return ()=>{
            clearRmlMediaBridge(attachmentsBrowser);
        };
    }, [
        attachmentsBrowser
    ]);
}
export { useRmlMediaBridge };
